export class DateType {
  public static Gregorian = 1;
  public static Hijri = 2;
}
